import request from '@/http/request'
import type { ApiResponse } from '@/types'
import type {
  UserState,
  LoginResponse,
  PasswordLoginForm,
  SmsLoginForm,
  RegisterForm,
} from '@/types/user'

// ========== 图形验证码 ==========

export interface CaptchaData {
  captchaKey: string
  captchaImage: string
}

export function getCaptchaImage(): Promise<ApiResponse<CaptchaData>> {
  return request.get('/learner/auth/captcha')
}

// ========== 密码登录 ==========

export function loginByPassword(data: PasswordLoginForm): Promise<ApiResponse<LoginResponse>> {
  return request.post('/learner/auth/login', data)
}

// ========== 短信验证码登录 ==========

export function sendLoginSmsCode(
  phone: string,
  captchaKey: string,
  captchaCode: string
): Promise<ApiResponse<void>> {
  return request.post(
    `/learner/auth/sms/send?phone=${phone}&scene=login&captchaKey=${captchaKey}&captchaCode=${captchaCode}`
  )
}

export function loginBySms(data: SmsLoginForm): Promise<ApiResponse<LoginResponse>> {
  return request.post('/learner/auth/login/sms', data)
}

// ========== 注册 ==========

export function sendRegisterSmsCode(
  phone: string,
  captchaKey: string,
  captchaCode: string
): Promise<ApiResponse<void>> {
  return request.post(
    `/learner/auth/sms/register?phone=${phone}&captchaKey=${captchaKey}&captchaCode=${captchaCode}`
  )
}

export function register(data: RegisterForm): Promise<ApiResponse<LoginResponse>> {
  return request.post('/learner/auth/register', data)
}

// ========== 刷新Token ==========

export function refreshToken(refreshToken: string): Promise<ApiResponse<LoginResponse>> {
  return request.post('/learner/auth/refresh', null, {
    headers: {
      'Refresh-Token': refreshToken,
    },
  })
}

// ========== 登出 ==========

export function logout(): Promise<ApiResponse<string>> {
  return request.post('/learner/auth/logout')
}

// ========== 微信登录（预留） ==========

export interface WechatQrCodeData {
  qrCodeUrl: string
  sceneKey: string
}

export interface WechatLoginStatus {
  state: 'PENDING' | 'SCANNED' | 'CONFIRMED' | 'EXPIRED'
  user?: UserState
  token?: string
}

export function getWechatQrCode(): Promise<ApiResponse<WechatQrCodeData>> {
  return request.get('/learner/auth/wechat/qrcode')
}

export function checkWechatLoginStatus(sceneKey: string): Promise<ApiResponse<WechatLoginStatus>> {
  return request.get('/learner/auth/wechat/status', { params: { sceneKey } })
}

// ========== 重置密码（预留） ==========

export interface ResetPasswordParams {
  phone: string
  smsCode: string
  newPassword: string
}

export interface VerifyResetCodeParams {
  phone: string
  smsCode: string
}

export function sendResetSmsCode(
  phone: string,
  captchaKey: string,
  captchaCode: string
): Promise<ApiResponse<void>> {
  return request.post(
    `/learner/auth/sms/send?phone=${phone}&scene=reset_password&captchaKey=${captchaKey}&captchaCode=${captchaCode}`
  )
}

export function verifyResetCode(data: VerifyResetCodeParams): Promise<ApiResponse<void>> {
  return request.post('/learner/auth/reset/verify', data)
}

export function resetPassword(data: ResetPasswordParams): Promise<ApiResponse<void>> {
  return request.post('/learner/auth/reset/password', data)
}
